import {
  LandingMediaKit as LandingMediaKitView,
  LandingAboutTNO as LandingAboutTNOView,
  LandingMediaKitProgramacion as LandingMediaKitProgramacionView,
  LandingMediaKitPaquetes as LandingMediaKitPaquetesView,
  LandingMediaKitsIndex as LandingMediaKitsIndexView,
  LandingMediaKitBusiness as LandingMediaKitBusinessView,
  LandingMediaKitTNOBusinessPatrocinio as LandingMediaKitTNOBusinessPatrocinioView,
  LandingMediaKitCreator as LandingMediaKitCreatorView,
  LandingMediaLabHome as LandingMediaLabHomeView,
  LandingMediaKitNoticias as LandingMediaKitNoticiasView,
  LandingMediaKitDosisPositiva as LandingMediaKitDosisPositivaView,
  LandingMediaKitPuntoDeFe as LandingMediaKitPuntoDeFeView,
  LandingMediaKitSomosPadres as LandingMediaKitSomosPadresView,
  LandingMediaKitVivirEnEquilibrio as LandingMediaKitVivirEnEquilibrioView,
  LandingMediaKitTNOSports as LandingMediaKitTNOSportsView,
  LandingMediaKitSiempreMasMusica as LandingMediaKitSiempreMasMusicaView,
  LandingMediaKitComercioCorporativo as LandingMediaKitComercioCorporativoView,
  LandingMediaKitDespuesDelEvento as LandingMediaKitDespuesDelEventoView,
  LandingMediaKitEnSintoniaConTuSalud as LandingMediaKitEnSintoniaConTuSaludView,
  LandingMediaKit2doEscalon as LandingMediaKit2doEscalonView,
  LandingMediaKitHablemosDeTodo as LandingMediaKitHablemosDeTodoView,
  LandingMediaKitVidaInmobiliaria as LandingMediaKitVidaInmobiliariaView,
  LandingMediaKitMarketingEnMovimiento as LandingMediaKitMarketingEnMovimientoView,
  LandingMediaKitLegalmenteEnFamilia as LandingMediaKitLegalmenteEnFamiliaView,
  LandingMediaKitEnProduccionConMem as LandingMediaKitEnProduccionConMemView,
  LandingGranFeriaEnProduccionConMem as LandingGranFeriaEnProduccionConMemView,
  LandingTotalEnProduccionConMem as LandingTotalEnProduccionConMemView,
  LandingRoldaEnProduccionConMem as LandingRoldaEnProduccionConMemView,
  LandingRoldaMemOnlyEnProduccionConMem as LandingRoldaMemOnlyEnProduccionConMemView,
  LandingMediaKitHoetPartners as LandingMediaKitHoetPartnersView,
  LandingMediaKitColegioAbogadosCaracas as LandingMediaKitColegioAbogadosCaracasView,
  LandingMediaKit3DeCopas as LandingMediaKit3DeCopasView,
  LandingMediaKitLacteosBarinas as LandingMediaKitLacteosBarinasView,
  LandingMediaKitBancaribe as LandingMediaKitBancaribeView,
  LandingMediaKitPapaupa as LandingMediaKitPapaupaView,
  LandingMediaKitMovistar as LandingMediaKitMovistarView,
  LandingMediaKitArtesco as LandingMediaKitArtescoView,
  LandingMediaKitNexusCultural as LandingMediaKitNexusCulturalView,
  LandingMediaKitAtache as LandingMediaKitAtacheView,
  LandingMediaKitDanimar as LandingMediaKitDanimarView,
  LandingMediaKitDanimarExpress as LandingMediaKitDanimarExpressView,
  LandingMediaKitChemical as LandingMediaKitChemicalView,
  LandingMediaKitCinepic as LandingMediaKitCinepicView,
  LandingMediaKitDaka as LandingMediaKitDakaView,
  LandingMediaKitSVP as LandingMediaKitSVPView,
  LandingMediaKitTallerProduccion as LandingMediaKitTallerProduccionView,
  LandingMediaKitDoctorCondominio as LandingMediaKitDoctorCondominioView,
  LandingMediaKitExpedientesDelDelito as LandingMediaKitExpedientesDelDelitoView,
  LandingMediaKitActitudPlateada as LandingMediaKitActitudPlateadaView,
  LandingMediaKitEventoPadel as LandingMediaKitEventoPadelView,
  LandingWikiOperadorAudiovisual as LandingWikiOperadorAudiovisualView,
  LandingWikiHome as LandingWikiHomeView,
  LandingWikiPautasExteriores as LandingWikiPautasExterioresView,
  LandingWikiSubidaProgramas as LandingWikiSubidaProgramasView,
  LandingWikiPublicarNoticiasTno as LandingWikiPublicarNoticiasTnoView,
  LandingMediaKitOpticaBerlud as LandingMediaKitOpticaBerludView,
  LandingMediaKitCorporacionTisem as LandingMediaKitCorporacionTisemView,
  LandingMediaKitCanguro as LandingMediaKitCanguroView,
  LandingMediaKitPrudence as LandingMediaKitPrudenceView,
  LandingMediaKitExpoSalud as LandingMediaKitExpoSaludView,
  LandingMediaKitPedroConLasMascotas as LandingMediaKitPedroConLasMascotasView,
  LandingMediaKitExpoMascotas as LandingMediaKitExpoMascotasView,
  LandingMediaKitExpoPetroleo as LandingMediaKitExpoPetroleoView,
  LandingMediaKitFranquiciasEnVenezuela as LandingMediaKitFranquiciasEnVenezuelaView,
  LandingMediaKitIndesagro as LandingMediaKitIndesagroView,
  LandingMediaKitAltamiraVillage as LandingMediaKitAltamiraVillageView,
  LandingMediaKitSmartTraining as LandingMediaKitSmartTrainingView,
  LandingMediaKitMerpoeste as LandingMediaKitMerpoesteView,
  LandingMediaKitLedHome as LandingMediaKitLedHomeView,
  LandingMediaKitMercosur as LandingMediaKitMercosurView,
  LandingMediaKitMercosurPodcast as LandingMediaKitMercosurPodcastView,
  LandingMediaKitBolsaValoresDescentralizada as LandingMediaKitBolsaValoresDescentralizadaView,
  LandingMediaKitAndreinaRoa as LandingMediaKitAndreinaRoaView,
  LandingMediaKitHarrisonMozo as LandingMediaKitHarrisonMozoView,
  LandingMediaKitBancoActivoMetas as LandingMediaKitBancoActivoMetasView,
  LandingMediaKitEmpireKeeway as LandingMediaKitEmpireKeewayView,
  LandingMediaKitHyundaiVenezuela as LandingMediaKitHyundaiVenezuelaView,
  LandingMediaKitDHLVenezuela as LandingMediaKitDHLVenezuelaView,
  LandingMediaKitLGVenezuela as LandingMediaKitLGVenezuelaView,
  LandingMediaKitCafeSanDomingo as LandingMediaKitCafeSanDomingoView,
  LandingMediaKitAlterGoldPrograma as LandingMediaKitAlterGoldProgramaView,
  LandingMediaKitAlterGoldPublicidad as LandingMediaKitAlterGoldPublicidadView,
  LandingMediaKitGrupoExpress as LandingMediaKitGrupoExpressView,
  LandingMediaKitOratoriaEstrategica as LandingMediaKitOratoriaEstrategicaView,
  LandingMediaKitDynamic as LandingMediaKitDynamicView,
  LandingMediaKitWMAutopartes as LandingMediaKitWMAutopartesView,
  LandingSortilegio as LandingSortilegioView,
  LandingPressStart as LandingPressStartView,
  LandingPressStartPresentation as LandingPressStartPresentationView,
  LandingTNOCon as LandingTNOConView,
  LandingCreatorsGuild as LandingCreatorsGuildView,
  LandingCreatorsGuildRoadmap as LandingCreatorsGuildRoadmapView,
  LandingBusinessLevel as LandingBusinessLevelView,
  LandingBusinessLevelPresentation as LandingBusinessLevelPresentationView,
  LandingMediaKitProposal as LandingMediaKitProposalView,
  LandingMediaKitProgramStatic as LandingMediaKitProgramStaticView,
  LandingCherrySoftware as LandingCherrySoftwareView,
  LandingCherryWeb as LandingCherryWebView,
  LandingCherryWebAnnaSanellia as LandingCherryWebAnnaSanelliaView,
  LandingPropuestaFarmafer as LandingPropuestaFarmaferView,
  LandingPropuestaGuomei as LandingPropuestaGuomeiView,
  LandingPropuestaNasiol as LandingPropuestaNasiolView,
  CherrySoftwareCrm as CherrySoftwareCrmView,
  Software as SoftwareView,
  DesignAgency as DesignAgencyView,
  Consulting as ConsultingView,
  Application as ApplicationView,
  DomainHosting as DomainHostingView,
  Marketing as MarketingView,
  Advertisement as AdvertisementView,
  PaymentApp as PaymentAppView,
  Course as CourseView,
  Crypto as CryptoView,
  Travel as TravelView,
  Event as EventView,
} from './views/landingPages';

import { PROGRAM_PROPOSAL_ROUTE_SLUGS } from './data/programGridMediaKitProposals';

import {
  NotFound as NotFoundView,
} from './views/supportingPages';

import {
  Main as MainLayout,
  Blank as BlankLayout,
} from './layouts';
import {
  TicketCredentialPage,
  TicketScannerPage,
} from './views/eventTicket';
import { Redirect, Route, Switch } from 'react-router-dom';

import React from 'react';
import WithLayout from 'WithLayout';

const Routes = () => {
  const pathNoTrail =
    typeof window !== 'undefined'
      ? window.location.pathname.replace(/\/+$/, '') || '/'
      : '';

  // Detectar si estamos en el dominio de Noticias TNO
  const isNoticiasDomain = typeof window !== 'undefined' && 
    (window.location.hostname === 'noticiastno.tnonetwork.com' ||
     window.location.pathname === '/noticias');

  // Detectar si estamos en el dominio o ruta de La Dosis Positiva
  const isDosisPositivaDomain = typeof window !== 'undefined' && 
    (window.location.hostname === 'ladosispositiva.tnonetwork.com' ||
     window.location.pathname === '/ladosispositiva');

  const isMarketingEnMovimientoDomain = typeof window !== 'undefined' &&
    (window.location.hostname === 'marketingenmovimiento.tnonetwork.com' ||
     pathNoTrail === '/marketingenmovimiento');

  const isLegalmenteEnFamiliaDomain =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'legalmenteenfamilia.tnonetwork.com' ||
      window.location.pathname === '/legalmenteenfamilia');

  const isEnProduccionConMemDomain =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'enproduccionconmem.tnonetwork.com' || pathNoTrail === '/enproduccionconmem');

  const isHoetPartnersDomain =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'hoet-partners.tnonetwork.com' ||
      window.location.pathname === '/hoet-partners');

  const isColegioAbogadosCaracasDomain =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'colegio-abogados-caracas.tnonetwork.com' ||
      pathNoTrail === '/colegio-abogados-caracas');

  const is3DeCopasDomain = typeof window !== 'undefined' &&
    (window.location.hostname === '3decopas.tnonetwork.com' ||
     pathNoTrail === '/3decopas');

  // Detectar si estamos en el dominio o ruta de Lácteos Barinas
  const isLacteosBarinasDomain = typeof window !== 'undefined' && 
    (window.location.hostname === 'lacteosbarinas.tnonetwork.com' ||
     window.location.pathname === '/lacteosbarinas');

  const isBancaribeDomain = typeof window !== 'undefined' && 
    (window.location.hostname === 'bancaribe.tnonetwork.com' ||
     window.location.pathname === '/bancaribe');

  const isMovistarDomain = typeof window !== 'undefined' && 
    (window.location.hostname === 'movistar.tnonetwork.com' ||
     window.location.pathname === '/movistar');

  const isDanimarExpressDomain = typeof window !== 'undefined' &&
    (window.location.hostname === 'danimar-express.tnonetwork.com' ||
     window.location.pathname === '/danimar-express');

  const isChemicalDomain = typeof window !== 'undefined' &&
    (window.location.hostname === 'chemical.tnonetwork.com' ||
     window.location.pathname === '/chemical');

  const isDanimarDomain = typeof window !== 'undefined' &&
    (window.location.hostname === 'danimar.tnonetwork.com' ||
     window.location.pathname === '/danimar');

  const isCinepicDomain = typeof window !== 'undefined' && 
     (window.location.hostname === 'supercines.tnonetwork.com' ||
      window.location.pathname === '/supercines');

  const isDakaDomain = typeof window !== 'undefined' && 
     (window.location.hostname === 'daka.tnonetwork.com' ||
      window.location.pathname === '/daka');

  const isSvpDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'svp.tnonetwork.com' ||
      window.location.pathname === '/svp');

  const isTallerProduccionDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'taller.tnonetwork.com' ||
     window.location.hostname === 'academy.tnonetwork.com' ||
     window.location.pathname === '/tallerproduccion');

  const isExpedientesDelDelitoDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'expedientesdeldelito.tnonetwork.com' ||
     window.location.pathname === '/expedientesdeldelito');

  const isActitudPlateadaDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'actitudplateada.tnonetwork.com' ||
     window.location.pathname === '/actitudplateada');

  const isEventoPadelDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'eventopadel.tnonetwork.com' ||
     window.location.pathname === '/eventopadel');

  const isWikiSubdomain =
    typeof window !== 'undefined' && window.location.hostname === 'wiki.tnonetwork.com';

  const isTnoMediaLabDomain =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'tnomedialab.com' ||
      window.location.hostname === 'www.tnomedialab.com' ||
      window.location.hostname === 'server1.tnomedialab.com' ||
      window.location.hostname === '162.0.214.75');

  const isOpticaBerludDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'opticaberlud.tnonetwork.com' ||
     window.location.pathname === '/opticaberlud');

  const isCorporacionTisemteDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'corporacion-tisemte.tnonetwork.com' ||
     window.location.pathname === '/corporacion-tisemte' ||
     window.location.hostname === 'corporacion-tisem.tnonetwork.com' ||
     window.location.pathname === '/corporacion-tisem');

  const isCanguroDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'canguro.tnonetwork.com' ||
     window.location.pathname === '/canguro');

  const isPrudenceDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'prudence.tnonetwork.com' ||
     window.location.pathname === '/prudence');

  const isExpoSaludDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'exposaludplus.tnonetwork.com' ||
     window.location.pathname === '/exposaludplus');

  const isPedroConLasMascotasDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'pedroconlasmascotas.tnonetwork.com' ||
     window.location.pathname === '/pedroconlasmascotas');

  const isExpoMascotasDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'expomascotas.tnonetwork.com' ||
     window.location.pathname === '/expomascotas');

  const isExpoPetroleoDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'expopetroleo.tnonetwork.com' ||
     window.location.pathname === '/expopetroleo');

  const isBusinessDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'tnobusiness.tnonetwork.com' ||
      window.location.hostname === 'business.tnonetwork.com' ||
      window.location.pathname === '/tnobusiness');

  const isPatrocinioTnoBusinessDomain =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'patrocinio-tno-business.tnonetwork.com' ||
      pathNoTrail === '/patrocinio-tno-business');

  const isSmartTrainingDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'smarttraining.tnonetwork.com' ||
      window.location.pathname === '/smarttraining');

  const isMerpoesteDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'merpoeste.tnonetwork.com' ||
      window.location.pathname === '/merpoeste');

  const isLedHomeDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'ledhome.tnonetwork.com' ||
      window.location.pathname === '/ledhome');

  const isMercosurDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'mercosur.tnonetwork.com' ||
      window.location.pathname === '/mercosur');

  const isOratoriaDomain = typeof window !== 'undefined' &&
     (window.location.hostname === 'oratoria.tnonetwork.com' ||
      window.location.pathname === '/oratoria');

  const isTnoConDomain =
    typeof window !== 'undefined' && window.location.hostname === 'tnocon.tnonetwork.com';

  const isPressStartDomain = typeof window !== 'undefined' &&
     window.location.pathname === '/pressstart';

  const isCreatorsGuildDomain = typeof window !== 'undefined' &&
    (window.location.hostname === 'creators.tnonetwork.com' ||
      window.location.hostname === 'producers.tnonetwork.com' ||
      window.location.pathname === '/creator' ||
      window.location.pathname === '/producer' ||
      window.location.pathname === '/creators-guild');

  let homeComponent = LandingMediaKitView;
  if (isTnoMediaLabDomain) homeComponent = LandingMediaLabHomeView;
  if (isCreatorsGuildDomain) homeComponent = LandingCreatorsGuildView;
  if (isNoticiasDomain) homeComponent = LandingMediaKitNoticiasView;
  if (isDosisPositivaDomain) homeComponent = LandingMediaKitDosisPositivaView;
  if (isMarketingEnMovimientoDomain) homeComponent = LandingMediaKitMarketingEnMovimientoView;
  if (isLegalmenteEnFamiliaDomain) homeComponent = LandingMediaKitLegalmenteEnFamiliaView;
  if (isEnProduccionConMemDomain) homeComponent = LandingMediaKitEnProduccionConMemView;
  if (isHoetPartnersDomain) homeComponent = LandingMediaKitHoetPartnersView;
  if (isColegioAbogadosCaracasDomain) homeComponent = LandingMediaKitColegioAbogadosCaracasView;
  if (is3DeCopasDomain) homeComponent = LandingMediaKit3DeCopasView;
  if (isLacteosBarinasDomain) homeComponent = LandingMediaKitLacteosBarinasView;
  if (isBancaribeDomain) homeComponent = LandingMediaKitBancaribeView;
  if (isMovistarDomain) homeComponent = LandingMediaKitMovistarView;
  if (isDanimarExpressDomain) homeComponent = LandingMediaKitDanimarExpressView;
  if (isChemicalDomain) homeComponent = LandingMediaKitChemicalView;
  if (isDanimarDomain) homeComponent = LandingMediaKitDanimarView;
  if (isDakaDomain) homeComponent = LandingMediaKitDakaView;
  if (isSvpDomain) homeComponent = LandingMediaKitSVPView;
  if (isCinepicDomain) homeComponent = LandingMediaKitCinepicView;
  if (isPedroConLasMascotasDomain) homeComponent = LandingMediaKitPedroConLasMascotasView;
  if (isExpoMascotasDomain) homeComponent = LandingMediaKitExpoMascotasView;
  if (isExpoPetroleoDomain) homeComponent = LandingMediaKitExpoPetroleoView;
  if (isExpoSaludDomain) homeComponent = LandingMediaKitExpoSaludView;
  if (isActitudPlateadaDomain) homeComponent = LandingMediaKitActitudPlateadaView;
  if (isEventoPadelDomain) homeComponent = LandingMediaKitEventoPadelView;
  if (isWikiSubdomain) homeComponent = LandingWikiHomeView;
  if (isOpticaBerludDomain) homeComponent = LandingMediaKitOpticaBerludView;
  if (isCorporacionTisemteDomain) homeComponent = LandingMediaKitCorporacionTisemView;
  if (isCanguroDomain) homeComponent = LandingMediaKitCanguroView;
  if (isPrudenceDomain) homeComponent = LandingMediaKitPrudenceView;
  if (isExpedientesDelDelitoDomain) homeComponent = LandingMediaKitExpedientesDelDelitoView;
  if (isTallerProduccionDomain) homeComponent = LandingMediaKitTallerProduccionView;
  if (isOratoriaDomain) homeComponent = LandingMediaKitOratoriaEstrategicaView;
  if (isTnoConDomain) homeComponent = LandingTNOConView;
  if (isPressStartDomain) homeComponent = LandingPressStartView;
  if (isSmartTrainingDomain) homeComponent = LandingMediaKitSmartTrainingView;
  if (isMerpoesteDomain) homeComponent = LandingMediaKitMerpoesteView;
  if (isLedHomeDomain) homeComponent = LandingMediaKitLedHomeView;
  if (isMercosurDomain) homeComponent = LandingMediaKitMercosurView;
  if (isBusinessDomain) homeComponent = LandingMediaKitBusinessView;
  if (isPatrocinioTnoBusinessDomain) homeComponent = LandingMediaKitTNOBusinessPatrocinioView;

  const render3DeCopasLayout = (matchProps) => (
    <WithLayout
      {...matchProps}
      component={LandingMediaKit3DeCopasView}
      layout={MainLayout}
    />
  );

  return (
    <Switch>
      {typeof window !== 'undefined' &&
        window.location.hostname === 'enproduccionconmem.tnonetwork.com' && (
        <>
          <Route
            exact
            path="/gran-feria"
            render={(matchProps) => (
              <WithLayout
                {...matchProps}
                component={LandingGranFeriaEnProduccionConMemView}
                layout={MainLayout}
              />
            )}
          />
          <Route
            exact
            path="/gran-feria/"
            render={(matchProps) => (
              <WithLayout
                {...matchProps}
                component={LandingGranFeriaEnProduccionConMemView}
                layout={MainLayout}
              />
            )}
          />
          <Route
            exact
            path="/total"
            render={(matchProps) => (
              <WithLayout
                {...matchProps}
                component={LandingTotalEnProduccionConMemView}
                layout={MainLayout}
              />
            )}
          />
          <Route
            exact
            path="/total/"
            render={(matchProps) => (
              <WithLayout
                {...matchProps}
                component={LandingTotalEnProduccionConMemView}
                layout={MainLayout}
              />
            )}
          />
          <Route
            exact
            path="/rolda-mem"
            render={(matchProps) => (
              <WithLayout
                {...matchProps}
                component={LandingRoldaMemOnlyEnProduccionConMemView}
                layout={MainLayout}
              />
            )}
          />
          <Route
            exact
            path="/rolda-mem/"
            render={(matchProps) => (
              <WithLayout
                {...matchProps}
                component={LandingRoldaMemOnlyEnProduccionConMemView}
                layout={MainLayout}
              />
            )}
          />
          <Route
            exact
            path="/rolda"
            render={(matchProps) => (
              <WithLayout
                {...matchProps}
                component={LandingRoldaEnProduccionConMemView}
                layout={MainLayout}
              />
            )}
          />
          <Route
            exact
            path="/rolda/"
            render={(matchProps) => (
              <WithLayout
                {...matchProps}
                component={LandingRoldaEnProduccionConMemView}
                layout={MainLayout}
              />
            )}
          />
        </>
      )}
      <Route
        exact
        path="/"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={homeComponent}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path={['/media-kit', '/media-kit/']}
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path={['/acerca', '/acerca/']}
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingAboutTNOView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path={['/programacion', '/programacion/']}
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitProgramacionView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path={['/paquetes', '/paquetes/']}
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitPaquetesView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path={['/media-kits', '/media-kits/']}
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitsIndexView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/tnobusiness"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitBusinessView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/patrocinio-tno-business"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitTNOBusinessPatrocinioView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/patrocinio-tno-business/"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitTNOBusinessPatrocinioView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/medialab"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitCreatorView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path={['/creadores', '/creadores/']}
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitCreatorView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path={['/talentos', '/talentos/']}
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitCreatorView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/cherry-dev"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingCherrySoftwareView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/cherry-software"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingCherrySoftwareView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/cherry-web"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingCherryWebView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/cherry-web/anna-sanellia"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingCherryWebAnnaSanelliaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/propuesta/farmafer"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingPropuestaFarmaferView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/propuesta/guomei"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingPropuestaGuomeiView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/propuesta/guomei/publicidad"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingPropuestaGuomeiView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/propuesta/nasiol"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingPropuestaNasiolView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/propuesta/nasiol/publicidad"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingPropuestaNasiolView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/cherry-software-crm"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={CherrySoftwareCrmView}
            layout={MainLayout}
          />
        )}
      />
      <Redirect exact from="/codigo-lechuza" to="/cherry-dev" />
      <Redirect exact from="/codigo-lechuza-crm" to="/cherry-software-crm" />
      <Route
        exact
        path="/landing-advertisement"
        render={(matchProps) => (
          <WithLayout {...matchProps} component={AdvertisementView} layout={MainLayout} />
        )}
      />
      <Route
        exact
        path="/landing-payment-app"
        render={(matchProps) => (
          <WithLayout {...matchProps} component={PaymentAppView} layout={MainLayout} />
        )}
      />
      <Route
        exact
        path="/landing-marketing"
        render={(matchProps) => (
          <WithLayout {...matchProps} component={MarketingView} layout={MainLayout} />
        )}
      />
      <Route
        exact
        path="/landing-software-company"
        render={(matchProps) => (
          <WithLayout {...matchProps} component={SoftwareView} layout={MainLayout} />
        )}
      />
      <Route
        exact
        path="/landing-course"
        render={(matchProps) => (
          <WithLayout {...matchProps} component={CourseView} layout={MainLayout} />
        )}
      />
      <Route
        exact
        path="/landing-crypto"
        render={(matchProps) => (
          <WithLayout {...matchProps} component={CryptoView} layout={MainLayout} />
        )}
      />
      <Route
        exact
        path="/landing-design-agency"
        render={(matchProps) => (
          <WithLayout {...matchProps} component={DesignAgencyView} layout={MainLayout} />
        )}
      />
      <Route
        exact
        path="/landing-consulting"
        render={(matchProps) => (
          <WithLayout {...matchProps} component={ConsultingView} layout={MainLayout} />
        )}
      />
      <Route
        exact
        path="/landing-application"
        render={(matchProps) => (
          <WithLayout {...matchProps} component={ApplicationView} layout={MainLayout} />
        )}
      />
      <Route
        exact
        path="/landing-domain-hosting"
        render={(matchProps) => (
          <WithLayout {...matchProps} component={DomainHostingView} layout={MainLayout} />
        )}
      />
      <Route
        exact
        path="/landing-travel"
        render={(matchProps) => (
          <WithLayout {...matchProps} component={TravelView} layout={MainLayout} />
        )}
      />
      <Route
        exact
        path="/landing-event"
        render={(matchProps) => (
          <WithLayout {...matchProps} component={EventView} layout={MainLayout} />
        )}
      />
      <Route
        exact
        path="/creator"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingCreatorsGuildView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/producer"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingCreatorsGuildView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path={['/creators-guild/roadmap', '/creators-guild/roadmap/']}
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingCreatorsGuildRoadmapView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/creators-guild"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingCreatorsGuildView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/business-level"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingBusinessLevelView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path={['/business-level/presentacion', '/business-level/presentacion/']}
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingBusinessLevelPresentationView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/noticias"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitNoticiasView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/tallerproduccion"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitTallerProduccionView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/oratoria"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitOratoriaEstrategicaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path={['/tnocon', '/tnocon/']}
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingTNOConView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/wmautopartes"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitWMAutopartesView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/sortilegio"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingSortilegioView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/pressstart"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingPressStartView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path={['/pressstart/presentacion', '/pressstart/presentacion/']}
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingPressStartPresentationView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/page-not-found"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={NotFoundView}
            layout={MainLayout}
          />
        )}
      />
      {/* Landings estáticas: acceso directo como antes */}
      <Route
        exact
        path="/ladosispositiva"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitDosisPositivaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/puntodefe"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitPuntoDeFeView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/somospadres"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitSomosPadresView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/vivirenequilibrio"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitVivirEnEquilibrioView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        path="/tnosports"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitTNOSportsView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        path="/siempremasmusica"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitSiempreMasMusicaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        path="/comerciocorporativo"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitComercioCorporativoView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        path="/despuesdelevento"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitDespuesDelEventoView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        path="/ensintoniacontusalud"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitEnSintoniaConTuSaludView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        path="/2doescalon"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKit2doEscalonView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        path="/hablemosdetodo"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitHablemosDeTodoView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        path="/vidainmobiliaria"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitVidaInmobiliariaView}
            layout={MainLayout}
          />
        )}
      />
      {PROGRAM_PROPOSAL_ROUTE_SLUGS.map((slug) => (
        <Route
          key={`program-media-kit-${slug}`}
          exact
          path={`/${slug}`}
          render={(matchProps) => (
            <WithLayout
              {...matchProps}
              component={LandingMediaKitProgramStaticView}
              layout={MainLayout}
              forcedSlug={slug}
            />
          )}
        />
      ))}
      <Route
        exact
        path="/marketingenmovimiento"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitMarketingEnMovimientoView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/gpm-eventos"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitProposalView}
            layout={MainLayout}
            staticOnly={true}
            forcedSlug="gpm-eventos"
          />
        )}
      />
      <Route
        exact
        path="/gpm-eventos/"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitProposalView}
            layout={MainLayout}
            staticOnly={true}
            forcedSlug="gpm-eventos"
          />
        )}
      />
      <Route
        exact
        path="/legalmenteenfamilia"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitLegalmenteEnFamiliaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/enproduccionconmem/rolda-mem"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingRoldaMemOnlyEnProduccionConMemView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/enproduccionconmem/rolda-mem/"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingRoldaMemOnlyEnProduccionConMemView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/enproduccionconmem/rolda"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingRoldaEnProduccionConMemView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/enproduccionconmem/rolda/"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingRoldaEnProduccionConMemView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/enproduccionconmem/gran-feria"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingGranFeriaEnProduccionConMemView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/enproduccionconmem/gran-feria/"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingGranFeriaEnProduccionConMemView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/enproduccionconmem/total"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingTotalEnProduccionConMemView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/enproduccionconmem/total/"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingTotalEnProduccionConMemView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/enproduccionconmem"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitEnProduccionConMemView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/enproduccionconmem/"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitEnProduccionConMemView}
            layout={MainLayout}
          />
        )}
      />
      <Redirect exact from="/show/enproduccionconmem/gran-feria" to="/enproduccionconmem/gran-feria" />
      <Redirect exact from="/show/enproduccionconmem/gran-feria/" to="/enproduccionconmem/gran-feria" />
      <Redirect exact from="/show/enproduccionconmem/total" to="/enproduccionconmem/total" />
      <Redirect exact from="/show/enproduccionconmem/total/" to="/enproduccionconmem/total" />
      <Redirect exact from="/show/enproduccionconmem/rolda-mem" to="/enproduccionconmem/rolda-mem" />
      <Redirect exact from="/show/enproduccionconmem/rolda-mem/" to="/enproduccionconmem/rolda-mem" />
      <Redirect exact from="/show/enproduccionconmem/rolda" to="/enproduccionconmem/rolda" />
      <Redirect exact from="/show/enproduccionconmem/rolda/" to="/enproduccionconmem/rolda" />
      <Redirect exact from="/show/enproduccionconmem" to="/enproduccionconmem" />
      <Redirect exact from="/show/enproduccionconmem/" to="/enproduccionconmem" />
      <Route
        exact
        path="/hoet-partners"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitHoetPartnersView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/colegio-abogados-caracas"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitColegioAbogadosCaracasView}
            layout={MainLayout}
          />
        )}
      />
      <Route exact path="/3decopas/" render={render3DeCopasLayout} />
      <Route exact path="/3decopas" render={render3DeCopasLayout} />
      <Route
        exact
        path="/lacteosbarinas"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitLacteosBarinasView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/bancaribe"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitBancaribeView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/papaupa"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitPapaupaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/movistar"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitMovistarView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/artesco"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitArtescoView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/nexus-cultural"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitNexusCulturalView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/atache"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitAtacheView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/danimar"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitDanimarView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/danimar-express"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitDanimarExpressView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/chemical"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitChemicalView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/supercines"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitCinepicView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/daka"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitDakaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/svp"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitSVPView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/doctorcondominioradio"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitDoctorCondominioView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/expedientesdeldelito"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitExpedientesDelDelitoView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/exposaludplus"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitExpoSaludView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/actitudplateada"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitActitudPlateadaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/wiki/subida-programas"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingWikiSubidaProgramasView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/wiki/publicar-noticias-tno"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingWikiPublicarNoticiasTnoView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/wiki/pautas-exteriores"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingWikiPautasExterioresView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/wiki/operador-audiovisual"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingWikiOperadorAudiovisualView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/wiki"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingWikiHomeView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/eventopadel"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitEventoPadelView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/opticaberlud"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitOpticaBerludView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/corporacion-tisemte"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitCorporacionTisemView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/corporacion-tisem"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitCorporacionTisemView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/canguro"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitCanguroView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/prudence"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitPrudenceView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/expomascotas"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitExpoMascotasView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/expopetroleo"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitExpoPetroleoView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/pedroconlasmascotas"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitPedroConLasMascotasView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/franquiciasenvenezuela"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitFranquiciasEnVenezuelaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/indesagro"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitIndesagroView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/altamiravillage"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitAltamiraVillageView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/smarttraining"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitSmartTrainingView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/ledhome"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitLedHomeView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/merpoeste"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitMerpoesteView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/mercosur"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitMercosurView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/mercosur-podcast"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitMercosurPodcastView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/bolsa-valores-descentralizada"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitBolsaValoresDescentralizadaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/andreina-roa"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitAndreinaRoaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/andreina-roa/"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitAndreinaRoaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/harrison-mozo"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitHarrisonMozoView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/harrison-mozo/"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitHarrisonMozoView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/banco-activo-metas-con-proposito"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitBancoActivoMetasView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/empire-keeway"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitEmpireKeewayView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/hyundai-venezuela"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitHyundaiVenezuelaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/dhl-venezuela"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitDHLVenezuelaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/lg-venezuela"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitLGVenezuelaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/cafe-san-domingo"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitCafeSanDomingoView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/alter-gold-programa"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitAlterGoldProgramaView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/alter-gold-publicidad"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitAlterGoldPublicidadView}
            layout={MainLayout}
          />
        )}
      />
      <Route
        exact
        path="/grupo-express"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitGrupoExpressView}
            layout={MainLayout}
          />
        )}
      />
      <Redirect exact from="/show/empire-keeway" to="/empire-keeway" />
      <Redirect exact from="/show/empire-keeway/" to="/empire-keeway" />
      <Redirect exact from="/show/banco-activo-metas-con-proposito" to="/banco-activo-metas-con-proposito" />
      <Redirect exact from="/show/banco-activo-metas-con-proposito/" to="/banco-activo-metas-con-proposito" />
      <Redirect exact from="/show/andreina-roa" to="/andreina-roa" />
      <Redirect exact from="/show/andreina-roa/" to="/andreina-roa" />
      <Redirect exact from="/show/harrison-mozo" to="/harrison-mozo" />
      <Redirect exact from="/show/harrison-mozo/" to="/harrison-mozo" />
      <Redirect exact from="/show/mercosur-podcast" to="/mercosur-podcast" />
      <Redirect exact from="/show/mercosur-podcast/" to="/mercosur-podcast" />
      <Redirect exact from="/show/bolsa-valores-descentralizada" to="/bolsa-valores-descentralizada" />
      <Redirect exact from="/show/bolsa-valores-descentralizada/" to="/bolsa-valores-descentralizada" />
      <Redirect exact from="/show/dhl-venezuela" to="/dhl-venezuela" />
      <Redirect exact from="/show/dhl-venezuela/" to="/dhl-venezuela" />
      <Redirect exact from="/show/cafe-san-domingo" to="/cafe-san-domingo" />
      <Redirect exact from="/show/cafe-san-domingo/" to="/cafe-san-domingo" />
      <Redirect exact from="/show/alter-gold-programa" to="/alter-gold-programa" />
      <Redirect exact from="/show/alter-gold-programa/" to="/alter-gold-programa" />
      <Redirect exact from="/show/alter-gold-publicidad" to="/alter-gold-publicidad" />
      <Redirect exact from="/show/alter-gold-publicidad/" to="/alter-gold-publicidad" />
      <Redirect exact from="/show/grupo-express" to="/grupo-express" />
      <Redirect exact from="/show/grupo-express/" to="/grupo-express" />
      {/* Misma landing que /3decopas; /show/:slug iba al visor de propuesta (API) y fallaba o no era el media kit completo */}
      <Redirect exact from="/show/3decopas" to="/3decopas" />
      <Redirect exact from="/show/3decopas/" to="/3decopas" />
      <Redirect exact from="/show/marketingenmovimiento" to="/marketingenmovimiento" />
      <Redirect exact from="/show/marketingenmovimiento/" to="/marketingenmovimiento" />
      <Redirect exact from="/show/siempremasmusica" to="/siempremasmusica" />
      <Redirect exact from="/show/siempremasmusica/" to="/siempremasmusica" />
      <Redirect exact from="/show/comerciocorporativo" to="/comerciocorporativo" />
      <Redirect exact from="/show/comerciocorporativo/" to="/comerciocorporativo" />
      <Redirect exact from="/show/despuesdelevento" to="/despuesdelevento" />
      <Redirect exact from="/show/despuesdelevento/" to="/despuesdelevento" />
      <Redirect exact from="/show/ensintoniacontusalud" to="/ensintoniacontusalud" />
      <Redirect exact from="/show/ensintoniacontusalud/" to="/ensintoniacontusalud" />
      <Redirect exact from="/show/2doescalon" to="/2doescalon" />
      <Redirect exact from="/show/2doescalon/" to="/2doescalon" />
      <Redirect exact from="/show/hablemosdetodo" to="/hablemosdetodo" />
      <Redirect exact from="/show/hablemosdetodo/" to="/hablemosdetodo" />
      {PROGRAM_PROPOSAL_ROUTE_SLUGS.map((slug) => (
        <React.Fragment key={`redirect-show-${slug}`}>
          <Redirect exact from={`/show/${slug}`} to={`/${slug}`} />
          <Redirect exact from={`/show/${slug}/`} to={`/${slug}`} />
        </React.Fragment>
      ))}
      <Redirect exact from="/show/patrocinio-tno-business" to="/patrocinio-tno-business" />
      <Redirect exact from="/show/patrocinio-tno-business/" to="/patrocinio-tno-business" />
      <Route
        exact
        path="/ticket/:token"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={TicketCredentialPage}
            layout={BlankLayout}
          />
        )}
      />
      <Route
        exact
        path="/admin/scanner"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={TicketScannerPage}
            layout={BlankLayout}
          />
        )}
      />
      {/* Propuestas dinámicas: cargadas desde el API (backoffice). Ruta /show/:slug */}
      <Route
        exact
        path="/show/:slug"
        render={(matchProps) => (
          <WithLayout
            {...matchProps}
            component={LandingMediaKitDynamicView}
            layout={MainLayout}
          />
        )}
      />
      <Redirect to="/page-not-found" />
    </Switch>
  );
};

export default Routes;
